import { collection, addDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebasedeconfig';
import notificationService from './notificationService';

class CallNotificationService {
  
  // Créer une notification d'appel entrant
  async createIncomingCallNotification(callerId, callerData, calleeId) {
    try {
      const message = `<strong>${callerData.username}</strong> vous appelle en vidéo`;
      
      await notificationService.createNotification(calleeId, {
        type: 'call_incoming',
        subtype: 'video',
        message,
        fromUserId: callerId,
        fromUsername: callerData.username,
        fromAvatar: callerData.avatar,
        callData: {
          callerId,
          callerUsername: callerData.username,
          callerAvatar: callerData.avatar,
          callType: 'video'
        },
        read: false,
        priority: 'high'
      });
      
      console.log('[CallNotification] Notification d\'appel entrant créée');
    } catch (error) {
      console.error('[CallNotification] Erreur création notification entrant:', error);
    }
  }

  // Créer une notification d'appel manqué
  async createMissedCallNotification(callerId, callerData, calleeId, duration = 0) {
    try {
      const message = `Appel manqué de <strong>${callerData.username}</strong>`;
      
      await notificationService.createNotification(calleeId, {
        type: 'call_missed',
        subtype: 'video',
        message,
        fromUserId: callerId,
        fromUsername: callerData.username,
        fromAvatar: callerData.avatar,
        callData: {
          callerId,
          callerUsername: callerData.username,
          callerAvatar: callerData.avatar,
          callType: 'video',
          duration,
          missedAt: new Date().toISOString()
        },
        read: false,
        priority: 'normal'
      });
      
      console.log('[CallNotification] Notification d\'appel manqué créée');
    } catch (error) {
      console.error('[CallNotification] Erreur création notification manqué:', error);
    }
  }

  // Créer une notification d'appel terminé
  async createCallEndedNotification(callerId, callerData, calleeId, duration) {
    try {
      if (duration < 5000) return; // Ne pas notifier les appels très courts
      
      const durationText = this.formatCallDuration(duration);
      const message = `Appel terminé avec <strong>${callerData.username}</strong> (${durationText})`;
      
      await notificationService.createNotification(calleeId, {
        type: 'call_ended',
        subtype: 'video',
        message,
        fromUserId: callerId,
        fromUsername: callerData.username,
        fromAvatar: callerData.avatar,
        callData: {
          callerId,
          callerUsername: callerData.username,
          callerAvatar: callerData.avatar,
          callType: 'video',
          duration,
          endedAt: new Date().toISOString()
        },
        read: false,
        priority: 'low'
      });
      
      console.log('[CallNotification] Notification d\'appel terminé créée');
    } catch (error) {
      console.error('[CallNotification] Erreur création notification terminé:', error);
    }
  }

  // Supprimer la notification d'appel entrant (quand l'appel est accepté/refusé)
  async removeIncomingCallNotification(calleeId, callerId) {
    try {
      // Cette fonction devrait être implémentée dans notificationService
      // pour supprimer les notifications d'appel entrant spécifiques
      console.log('[CallNotification] Suppression notification d\'appel entrant');
    } catch (error) {
      console.error('[CallNotification] Erreur suppression notification entrant:', error);
    }
  }

  // Formater la durée d'appel
  formatCallDuration(duration) {
    const seconds = Math.floor(duration / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    if (minutes > 0) {
      return `${minutes}min ${remainingSeconds}s`;
    }
    return `${remainingSeconds}s`;
  }

  // Créer une notification de rappel automatique
  async createCallbackSuggestion(calleeId, callerData) {
    try {
      const message = `Vous pouvez rappeler <strong>${callerData.username}</strong>`;
      
      await notificationService.createNotification(calleeId, {
        type: 'call_callback',
        subtype: 'suggestion',
        message,
        fromUserId: callerData.callerId,
        fromUsername: callerData.username,
        fromAvatar: callerData.avatar,
        callData: {
          callerId: callerData.callerId,
          callerUsername: callerData.username,
          callerAvatar: callerData.avatar,
          callType: 'video',
          suggestedAt: new Date().toISOString()
        },
        read: false,
        priority: 'low',
        autoExpire: true, // Se supprime automatiquement après un temps
        expiresAt: new Date(Date.now() + 30 * 60 * 1000) // 30 minutes
      });
      
      console.log('[CallNotification] Suggestion de rappel créée');
    } catch (error) {
      console.error('[CallNotification] Erreur création suggestion rappel:', error);
    }
  }

  // Nettoyer les anciennes notifications d'appels
  async cleanupOldCallNotifications(userId, olderThanDays = 7) {
    try {
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() - olderThanDays);
      
      // Cette fonction devrait être implémentée pour nettoyer
      // les anciennes notifications d'appels
      console.log('[CallNotification] Nettoyage des anciennes notifications d\'appels');
    } catch (error) {
      console.error('[CallNotification] Erreur nettoyage notifications:', error);
    }
  }
}

// Instance singleton
const callNotificationService = new CallNotificationService();
export default callNotificationService; 